<template>
  <div>
    <slot name="filters"></slot>
    <div>
      <table class="table table-zebra">
        <thead>
          <tr>
            <th v-for="column in columns" :key="`column.th.${column.key}`">
              <div class="flex group" :class="{ 'cursor-pointer': column.sortable !== false }">
                {{ column.label }}

                <div v-if="column.sortable !== false">
                  <a
                    v-if="sort.order === 'desc'"
                    @click="$emit('sort-updated', { key: column.key.toLowerCase(), order: 'asc' })"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      :class="sortClass(column.key)"
                      class="rounded-sm cursor-pointer group-hover:opacity-100 h-4 w-4 ml-2"
                      viewBox="0 0 24 24"
                      stroke-width="2.5"
                      stroke="currentColor"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <line x1="12" y1="5" x2="12" y2="19" />
                      <line x1="18" y1="13" x2="12" y2="19" />
                      <line x1="6" y1="13" x2="12" y2="19" />
                    </svg>
                  </a>
                  <a v-else @click="$emit('sort-updated', { key: column.key.toLowerCase(), order: 'desc' })">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      :class="sortClass(column.key)"
                      class="rounded-sm cursor-pointer group-hover:opacity-100 h-4 w-4 ml-2"
                      viewBox="0 0 24 24"
                      stroke-width="2.5"
                      stroke="currentColor"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <line x1="12" y1="5" x2="12" y2="19" />
                      <line x1="18" y1="11" x2="12" y2="5" />
                      <line x1="6" y1="11" x2="12" y2="5" />
                    </svg>
                  </a>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in rows" :key="`row.${index}`" @click="handleClick(row)">
            <td
              v-for="column in columns"
              :key="`row.${index}.column.${column.key}`"
              :class="{ 'cursor-pointer': clickable }"
            >
              <slot :name="`td-${column.key}`" :row="row" :column="column">
                {{ formatTableData(row[column.key], column) }}
              </slot>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    columns: {
      type: Array,
      required: true,
    },
    rows: {
      type: Array,
      required: true,
    },
    filters: {
      type: Array,
      required: false,
      default: () => {
        return [];
      },
    },
    sort: {
      type: Object,
      required: false,
      default: () => {
        return {};
      },
    },
    clickFn: {
      type: Function,
      required: false,
    },
  },
  computed: {
    clickable() {
      return typeof this.clickFn === 'function';
    },
  },
  methods: {
    handleClick(row) {
      if (!this.clickable) return;
      this.clickFn(row);
    },
    sortClass(columnKey) {
      let matchedSortingName = this.sort.key.toLowerCase() == columnKey.toLowerCase() ? true : false;
      return {
        'opacity-100': matchedSortingName,
        'opacity-0': !matchedSortingName,
      };
    },
    formatTableData(data, column) {
      if (!column.formatter || typeof column.formatter !== 'function') return data;

      return column.formatter(data);
    },
  },
};
</script>
